// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scroll-content {
    overflow-x: auto;
}

.table-container {
    width: 100%; /* Adjust the width as needed */
    height: 100%; /* Adjust the width as needed */
    overflow: auto; /* Enable horizontal scrollbar */
}

table {
    width: 100%; /* Adjust the width as needed */
    border-collapse: collapse;
}

/* Optional: Add styling for table cells, borders, etc. */
table td, table th {
    border: 1px solid #ccc;
    padding: 8px;
    text-align: center; /* Align text in the center */
}

/**/
/**/
.table-wrapper {
    width: 100%;
    overflow-x: auto; /* allow horizontal scroll */
    -webkit-overflow-scrolling: touch; /* smooth scrolling on iOS */
}

/* ensure table can be wider than viewport and remains readable */
.styled-table {
    width: 100%;
    min-width: 640px; /* adjust to your expected column count */
    border-collapse: collapse;
    table-layout: auto;
}

/* make cell contents not wrap so columns keep width and horizontal scroll appears */
.styled-table td, .styled-table th {
    white-space: nowrap;
    padding: 8px;
}

/* optional: reduce min-width on very small devices */
@media (max-width: 420px) {
    .styled-table {
        min-width: 520px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/framework/components/list/api-table/api-table.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW,EAAE,+BAA+B;IAC5C,YAAY,EAAE,+BAA+B;IAC7C,cAAc,EAAE,gCAAgC;AACpD;;AAEA;IACI,WAAW,EAAE,+BAA+B;IAC5C,yBAAyB;AAC7B;;AAEA,yDAAyD;AACzD;IACI,sBAAsB;IACtB,YAAY;IACZ,kBAAkB,EAAE,6BAA6B;AACrD;;AAEA,GAAG;AACH,GAAG;AACH;IACI,WAAW;IACX,gBAAgB,EAAE,4BAA4B;IAC9C,iCAAiC,EAAE,4BAA4B;AACnE;;AAEA,iEAAiE;AACjE;IACI,WAAW;IACX,gBAAgB,EAAE,yCAAyC;IAC3D,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA,oFAAoF;AACpF;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA,qDAAqD;AACrD;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".scroll-content {\n    overflow-x: auto;\n}\n\n.table-container {\n    width: 100%; /* Adjust the width as needed */\n    height: 100%; /* Adjust the width as needed */\n    overflow: auto; /* Enable horizontal scrollbar */\n}\n\ntable {\n    width: 100%; /* Adjust the width as needed */\n    border-collapse: collapse;\n}\n\n/* Optional: Add styling for table cells, borders, etc. */\ntable td, table th {\n    border: 1px solid #ccc;\n    padding: 8px;\n    text-align: center; /* Align text in the center */\n}\n\n/**/\n/**/\n.table-wrapper {\n    width: 100%;\n    overflow-x: auto; /* allow horizontal scroll */\n    -webkit-overflow-scrolling: touch; /* smooth scrolling on iOS */\n}\n\n/* ensure table can be wider than viewport and remains readable */\n.styled-table {\n    width: 100%;\n    min-width: 640px; /* adjust to your expected column count */\n    border-collapse: collapse;\n    table-layout: auto;\n}\n\n/* make cell contents not wrap so columns keep width and horizontal scroll appears */\n.styled-table td, .styled-table th {\n    white-space: nowrap;\n    padding: 8px;\n}\n\n/* optional: reduce min-width on very small devices */\n@media (max-width: 420px) {\n    .styled-table {\n        min-width: 520px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
